import { render, staticRenderFns } from "./CDProfiles.vue?vue&type=template&id=08498850&scoped=true&"
import script from "./CDProfiles.vue?vue&type=script&lang=js&"
export * from "./CDProfiles.vue?vue&type=script&lang=js&"
import style0 from "./CDProfiles.vue?vue&type=style&index=0&id=08498850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08498850",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
